import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextMaskModule } from 'angular2-text-mask';
import { ProductSelectorDialogComponent } from '../../shared/components/product-selector-dialog/product-selector-dialog.component';
import { SharedModule } from '../../shared/shared.module';
import { ProductService } from '../product/service/product.service';
import { AssetRoutingModule } from './asset-routing.module';
import { AssetAddComponent } from './components/add/asset-add.component';
import { AssetListResultComponent } from './components/asset-list-results/asset-list-results.component';
import { AssetPhotoUploadProgressDialog } from './components/asset-photo-upload-progress-dialog/asset-photo-upload-progress-dialog.component';
import { AssetAttachmentDialog } from './components/asset-view-attachment-dialog/asset-view-attachment-dialog.component';
import { BulkAddAssetsStatusComponent } from './components/bulk-add-asset-status/bulk-add-asset-status.component';
import { AssetEditComponent } from './components/edit/asset-edit.component';
import { AssetListComponent } from './components/list/asset-list.component';
import { SiteSelectorDialogComponent } from './components/site-selector/site-selector-dialog.component';
import { SitesDropdownComponent } from './components/sites-dropdown/sites-dropdown.component';
import { AssetViewComponent } from './components/view/asset-view.component';
import { AssetService } from './service/asset.service';
import { BulkAddAssetStatusService } from './service/bulk-add-asset-status.service';

@NgModule({
  imports: [CommonModule, SharedModule, TextMaskModule, AssetRoutingModule],
  declarations: [
    AssetListComponent,
    AssetListResultComponent,
    AssetViewComponent,
    AssetEditComponent,
    AssetAddComponent,
    ProductSelectorDialogComponent,
    SiteSelectorDialogComponent,
    SitesDropdownComponent,
    BulkAddAssetsStatusComponent,
    AssetPhotoUploadProgressDialog,
    AssetAttachmentDialog
  ],
  exports: [
    AssetListComponent,
    AssetPhotoUploadProgressDialog,
    AssetAttachmentDialog
  ],
  providers: [ProductService, AssetService, BulkAddAssetStatusService],
  entryComponents: [
    ProductSelectorDialogComponent,
    SiteSelectorDialogComponent,
    AssetPhotoUploadProgressDialog,
    AssetAttachmentDialog
  ]
})
export class AssetModule {}
